import { Component } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

export interface IDialogYesNoInputData {
    message: string;
    buttonText: string;
    confirmTextToInput: string;
}

@Component({
    selector: 'fi-dialog-yes-no-input',
    templateUrl: './dialog-yes-no-input.component.html',
    styleUrls: ['./dialog-yes-no-input.component.scss'],
    standalone: false,
})
export class DialogYesNoInputComponent extends FiDialogsContentBase<IDialogYesNoInputData, boolean> {
    confirmText = '';

    getYesButtonText() {
        return this.data.buttonText.toUpperCase();
    }

    isYesButtonDisabled() {
        return this.confirmText !== this.data.confirmTextToInput;
    }
}
